import {useEffect, useLayoutEffect, useState} from "react";
import {  GetContractorById, UpdateContractor
} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi";
import {Contractor} from "../../../../../models/Contractor";
import {toast} from "react-toastify";
import {GetAllServiceType} from "../../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {getPhotoPicker} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg, isEmailFormat, isPhoneFormat} from '../../../../../Apis/functions';
import routes from '../../../../../Routes/routes';
import {useLocation} from 'react-router-dom';
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const EmployeeFlowContractorUpdateApp =({
    t,
    params,
    dispatch,
    navigate,
    workShiftsList,
    customizedList,
    setEmptyFields,
    isValidDob,
    isValidPassword,
    photoPicker,
    permission,
    setWorkShiftsList,
    setCustomizedList,
    setSecretModal,
    setSecretKey,
    setSteps,
    modified,
    setModified,
    setPhotoPicker
})=>{

    const location = useLocation();
    let { state } = location;

    const [getAllServiceType, setGetAllServiceType] = useState([])
    const [user, setUser] = useState({...Contractor});

    useLayoutEffect(() => {
        setSteps([t("company_details"), t("manager_details"), t("photo"), t("access_right")]);
    }, [permission, t]);

    useEffect(()=>{
        dispatch(GetAllServiceType()).then(({payload:{data:{data}}})=>{
            setGetAllServiceType(data)
        });
    },[dispatch]);

    // Form handeler Function
    const FormHandler = () => {
        const emailOk = isEmailFormat(user.email);
        const phoneOk = isPhoneFormat(user.phoneNumber);

        if (!user.isValid() ||
            !isValidDob ||
            !phoneOk ||
            !emailOk ||
            !isValidPassword
        ) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true)
        } else {
            setEmptyFields(false);
            updateContractor();
        }
    };

    const updateContractor = () => {
        const customs = customizedList
            .filter((element) => element.added === true && element.new === true)
            .map(({ zoneId, zoneName, dayId, from, to }) => ({
                zoneId: zoneId,
                zoneName: zoneName,
                dayId: dayId,
                from: from,
                to: to,
            }));

        let imageFile = getPhotoPicker(photoPicker);
        const addPw = user?.password?.trim() !== '' && user?.password !== null;
        const requestData = {
            data: {
                ...user.toCreateUpdate(addPw ? user?.password.trim() : null),
                workShifts: workShiftsList,
                customs
            },
            file: imageFile,
            updateImage: user.selfie !== null,
            setModified
        };
        dispatch(UpdateContractor(requestData)).then(({payload:{data:{success, data, code}}}) => {
            if (success) {
                if(data?.secret && addPw ){
                    setSecretModal(true);
                    setSecretKey(data?.secret)
                }
                toast.success(t('has_been_updated_successfully'));
                setEmptyFields(false);
            }else{
                errorMsg(code)
            }
        });
    }

    useEffect(() => {
        getContractorInfo();
    }, []);

    useEffect(() => {
        if(modified){
            getContractorInfo();
            setModified(false);
        }
    }, [modified]);

    const getContractorInfo = () => {
        dispatch(GetContractorById(params?.id)).then(({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setUser((prevData) => ({
                        ...prevData,
                        ...data,
                    }));
                    if (data?.selfie) {
                        setPhotoPicker(prev => ({
                            ...prev,
                            previewImage: `data:image/jpeg;base64,${data.selfie}`
                        }));
                    }
                    if (data?.customs?.length > 0) {
                        setCustomizedList(data?.customs?.map((item) => ({ ...item, added: true, new: false })));
                    }
                    if (data?.workShifts?.length > 0) {
                        setWorkShiftsList(data?.workShifts.map((shift) => ({
                            ...shift,
                            added: true,
                            new: false
                        })));
                    }
                }
            },
        );
    }

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl, {
                state: {...state }
            });
        } else {
            navigate(routes.contractor.list)
        }
    }

    return {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack
    };
}
